export default __webpack_public_path__ + "static/media/custom-solutions-bg.3092b77d.png";